// import { toValue } from 'vue'
import resolve from '../utils/resolve'

export function useDataFilter(filter) {
  const dataQueryStore = inject('data-query-store')
  const label = computed(() => toValue(filter)?.label)
  const isLabelNoun = computed(() => toValue(filter)?.isLabelNoun !== false)
  const includeLabelInSimpleValue = computed(
    () => toValue(filter)?.includeLabelInSimpleValue,
  )
  const key = computed(() => toValue(filter)?.filterKey)
  const by = computed(() => toValue(filter)?.by)
  const options = computed(() => toValue(filter)?.options)

  const value = computed(() => dataQueryStore?.value?.state?.value?.filters?.[key?.value])
  const getOptionValue = (option) => {
    return by.value ? resolve(option, by.value) : option.value || option
  }
  const clear = () => {
    dataQueryStore?.value?.actions.updateFilter({ key: key?.value, value: undefined })
  }
  const selectedOptions = computed(() => {
    const val = value?.value
    if (val === undefined)
      return undefined
    if (!Array.isArray(val))
      return options.value?.filter(option => getOptionValue(option) == val)
    return options.value?.filter(option => val.includes(getOptionValue(option)))
  })
  const firstSelectedOption = computed(() => {
    if (Array.isArray(selectedOptions.value))
      return selectedOptions.value?.[0]
    else return selectedOptions.value
  })
  const otherSelectedOptions = computed(() => {
    if (!Array.isArray(selectedOptions.value))
      return 0
    const count = selectedOptions.value?.length
    return count ? count - 1 : 0
  })

  return {
    key,
    label,
    by,
    options,
    value,
    getOptionValue,
    clear,
    selectedOptions,
    firstSelectedOption,
    otherSelectedOptions,
    isLabelNoun,
    includeLabelInSimpleValue,
  }
}
